import Vue from 'vue'
import VueRouter from "vue-router"

import Auth0 from "@/components/auth/Auth0"
import Team from "@/components/profile/Team"
import Home from "@/components/Home"
import Company from "@/components/Company"
import iAnnotateConfiguration from "@/components/iAnnotateConfiguration"
import LicenseKey from "@/components/LicenseKey"
import DeploymentGuide from '@/components/DeploymentGuide'
import DeploymentGuideWithPdf from '@/components/DeploymentGuideWithPdf'
import ChangePassword from "@/components/profile/ChangePassword"
import auth0 from "./auth0-client";
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/reset-password/:reset_token', name: 'ResetPassword', component: Auth0},
    {path: '/auth', name: 'Auth', component: Auth0},
    {
      path: '/', name: 'Home', component: Home, children: [
        {path: '/profile/change_password', name: 'ChangePassword', component: ChangePassword},
        {path: '/profile/logout', name: 'LogOut', component: null},
        {path: '/profile/team', name: 'Team', component: Team},

        {path: '/company', name: 'Company', component: Company},
        {path: '/iAnnotate_configuration', name: 'IAnnotate', component: iAnnotateConfiguration},
        {path: '/license', name: 'LicenseKey', component: LicenseKey},
        {path: '/support', name: 'Support',},
        {path: '/deployment_guide', name: 'DeploymentGuide', component: DeploymentGuide},
        {path: '/deployment_guide_pdf', name: 'DeploymentGuideWithPdf', component: DeploymentGuideWithPdf},
        {path: '/', name: 'Company', component: Company},
      ]
    },
  ]
})

router.beforeEach(async (to, from ,next) => {
  const isAuthenticated = await auth0.isAuthenticated();
  // console.log(to.path, {isAuthenticated});
  if ("code" in to.query && "state" in to.query) {
    try {
      await auth0.signInRedirectCallback(to.fullPath);
      return next("/");
    } catch (e) {
      console.error(e.message);
      return next("/auth");
    }
  }

  if (to.path === "/profile/logout" && isAuthenticated) {
    await auth0.signOut();
    return next();
  }
  if (to.path === '/support') {
    window.open("https://help.folia.com/knowledge/iannotate-for-enterprise", '_blank').focus();
    to.path = '/company'
  }
  if (['Auth', 'ResetPassword'].includes(to.name)) return next();
  if (!isAuthenticated) return next('/auth');
  next();
})

export default router